module.exports = __webpack_public_path__ + "static/media/poster_replacement_old.924a2fa7.png";